import { useI18n, useLocalePath } from '#imports'

export function isLocalUrl(url: string): boolean {
  return url.startsWith('http://') || url.startsWith('https://')
}

export function useUrlUtils() {
  const { availableLocales } = useI18n()
  const localePath = useLocalePath()

  function isLocalePath(path: string): boolean {
    return availableLocales.some((loc: string) => path.startsWith(`/${loc}/`))
  }

  /**
   * Normalizes a URL for navigation:
   * absolute URLs and already locale-prefixed paths are returned as is,
   * other paths get the current locale prefix.
   */
  function getNormalizedUrl(url: string | null | undefined): string | null {
    if (!url) return null
    if (isLocalUrl(url) || isLocalePath(url)) return url
    return localePath(url)
  }

  return { isLocalUrl, isLocalePath, getNormalizedUrl }
}
